/**
 * 积分流水的取值名单。服务端写流水、后台和玩家端显示流水都以这里为准，各端按这些值取自己的文案，
 * 测试会检查每个值在各端都有名称。
 */

/**
 * 付费点：扣费流水的 reason 就是付费点名，失败退款是「付费点名_refund」。
 * 新增付费点：加到这里，再给后台和玩家端各补一条名称文案。
 */
export const PAID_ACTIONS = Object.freeze(['turn_play', 'full_run_video', 'intent_video_on_demand', 'novel_turn', 'novel_correction', 'novel_drama_session'])

export function paidActionRefundReason(action) {
  return `${action}_refund`
}

/** 流水 reason 属于哪个付费点，不是付费点的流水返回 null。 */
export function paidActionOfReason(reason) {
  for (const action of PAID_ACTIONS) {
    if (reason === action) return { action, refund: false }
    if (reason === paidActionRefundReason(action)) return { action, refund: true }
  }
  return null
}

/** 付费点以外的流水 reason。llm、visual_game_tts 是按调用计费改成 model_usage 之前的旧流水。 */
export const LEDGER_REASONS = Object.freeze([
  'signup_gift',
  'purchase',
  'purchase_paid',
  'purchase_bonus',
  'daily_claim',
  'admin_adjustment',
  'manual_admin_grant',
  'platform_seed',
  'model_usage',
  'llm',
  'visual_game_tts',
  'payment_refund_reversal',
  'payment_dispute_reversal',
  'unlock_episode',
  'unlock_branch',
  'unlock_continue',
  'unlock_ending',
])

/** 流水 source。legacy_admin 是商业化一期迁移前的人工调整。 */
export const LEDGER_SOURCES = Object.freeze([
  'admin',
  'legacy_admin',
  'daily_reward',
  'visual_game_signup',
  'platform',
  'stripe',
  'system',
  'gameplay',
  'unlock',
  'llm',
  'tts',
  'image_generation',
  'video_generation',
])

/** 流水 ref_type：reason 对应的业务对象。 */
export const LEDGER_REF_TYPES = Object.freeze([
  'admin_action',
  'daily_claim',
  'order',
  'run_turn',
  'run_correction',
  'run_video',
  'intent_video_request',
  'unlock',
  'source',
  'llm_chat',
  'llm_operation',
  'tts_operation',
  'visual_game_tts',
  'image_operation',
  'video_operation',
])

/** 按调用计费（model_usage）的流水按 ref_type 分出模型类别。 */
export const MODEL_USAGE_KIND_BY_REF_TYPE = Object.freeze({
  llm_chat: 'llm',
  llm_operation: 'llm',
  tts_operation: 'tts',
  visual_game_tts: 'tts',
  image_operation: 'image',
  video_operation: 'video',
})
